var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAqaLogoPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 762.62 428.77",
    style: {
      enableBackground: "new 0 0 762.62 428.77"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#371376;}\n\t.st1{fill:#C8194B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.36,343.69c-19.8,0-37.7-3.87-53.69-11.61c-15.99-7.74-29.83-18.09-41.5-31.03 c-11.68-12.94-20.69-27.6-27.03-43.98c-6.35-16.37-9.52-33.19-9.52-50.45c0-18.02,3.36-35.22,10.09-51.59 c6.72-16.37,15.99-30.97,27.79-43.79c11.8-12.81,25.83-22.97,42.07-30.46c16.24-7.48,33.89-11.23,52.92-11.23 c19.54,0,37.37,3.94,53.49,11.81c16.12,7.87,29.89,18.41,41.31,31.6c11.42,13.2,20.24,27.92,26.46,44.17 c6.22,16.25,9.33,33,9.33,50.26c0,17.77-3.23,34.84-9.71,51.21c-6.47,16.37-15.61,30.97-27.41,43.79 c-11.8,12.82-25.77,22.91-41.88,30.27C416.97,340.02,399.39,343.69,380.36,343.69z M380.74,297.24c12.95,0,24.24-2.6,33.89-7.8 c9.64-5.2,17.83-12.12,24.56-20.75c6.72-8.63,11.74-18.4,15.04-29.31c3.3-10.91,4.95-21.83,4.95-32.75 c0-11.67-1.78-22.97-5.33-33.88c-3.56-10.91-8.76-20.56-15.61-28.94c-6.85-8.38-15.11-15.1-24.75-20.18 c-9.65-5.08-20.69-7.61-33.12-7.61c-12.44,0-23.55,2.61-33.32,7.8c-9.78,5.21-18.03,12.13-24.75,20.75 c-6.73,8.63-11.8,18.34-15.23,29.13c-3.43,10.79-5.14,21.77-5.14,32.93c0,11.68,1.77,22.97,5.33,33.89 c3.55,10.92,8.69,20.56,15.42,28.94c6.72,8.38,14.98,15.11,24.75,20.18C357.19,294.71,368.3,297.24,380.74,297.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.95,343.59L190.58,73.26h-53.3L37.51,343.59h54.07l22.04-65.77l44.95,0.08l55.45,0.1l21.86,65.58 H289.95z M163.92,127.7l36.66,109.98l-73.52,0.02L163.92,127.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M713.47,343.59L614.09,73.26h-53.3l-99.76,270.33h54.07l22.04-65.77l44.95,0.08l55.45,0.1l21.86,65.58 H713.47z M587.44,127.7l36.66,109.98l-73.52,0.02L587.44,127.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M372.32,243.83H426l89.09,99.76h-54.06L372.32,243.83z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAqaLogoPurple);
export default __webpack_public_path__ + "static/media/aqa-logo-purple.8c7b67fc1ef9c425ee21924e00b3bdd1.svg";
export { ForwardRef as ReactComponent };